import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

export function useAnalytics() {
  const location = useLocation();
  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    // Track initial page view and subsequent route changes
    trackPageView(location.pathname);
    prevPathname.current = location.pathname;
  }, [location.pathname]);
}
